<template>
  <div class="mall-product-grid">
    <MallRoundTabs
      v-if="subTabs.length > 0"
      :tabs="subTabs"
      :value="subTab"
      @change="$emit('sub-tab-change', $event)"
    />
    <div class="mall-product-grid__list">
      <MallProductCard
        v-for="product in products"
        :key="product.id"
        :product="product"
        :selected="product.id === selectedProductId"
        @click="$emit('select', product.id)"
      />
    </div>
  </div>
</template>

<script>
import MallRoundTabs from '@/components/new/molecules/MallRoundTabs.vue'
import MallProductCard from '@/components/new/molecules/MallProductCard.vue'

export default {
  name: 'MallProductGrid',
  components: {
    MallRoundTabs,
    MallProductCard,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    selectedProductId: {
      type: [Number, String],
      default: null,
    },
    // 하위 분류 탭 [{ key, label }] (없으면 미노출)
    subTabs: {
      type: Array,
      default: () => [],
    },
    subTab: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.mall-product-grid {
  display: flex;
  padding: 16px 16px 32px 16px;
  flex-direction: column;
  gap: 12px;
}

.mall-product-grid__list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 8px;
  row-gap: 12px;
  align-items: start;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallProductGrid.vue